import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from "@angular/router";
import {AppConstants} from "../../../shared/constants/app-constant";
import {EnquiryService} from "../../../shared/services/enquiry.service";
import {AlertService} from "../../../shared/services/alert.service";

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
    @Output() formSubmitted = new EventEmitter<boolean>();  // Event emitter to notify parent

    submitted: any = false;
    courses = AppConstants.courses;
    enquiryForm!: FormGroup;
    isDropdownOpen = false;
    selectedCourse: any = null;
    constructor(private fb: FormBuilder, public router: Router, private enquiryService: EnquiryService, private alertService : AlertService)
     {
        this.enquiryForm = this.fb.group({
            fullName: ['', Validators.required],
            contact: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            address: ['', Validators.required],
        });
    }

  ngOnInit(): void {
  }



    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    selectCourse(course: any) {
        this.selectedCourse = course;
        this.isDropdownOpen = false;
    }

    onSubmit() {
        this.submitted = true;
        if (!this.enquiryForm.valid) {
            return;
        }
        if (this.submitted && this.selectedCourse) {
            const params = {
                name: (this.enquiryForm && this.enquiryForm.getRawValue() && this.enquiryForm.getRawValue().fullName) ? this.enquiryForm.getRawValue().fullName : '',
                email: (this.enquiryForm && this.enquiryForm.getRawValue() && this.enquiryForm.getRawValue().email) ? this.enquiryForm.getRawValue().email : '',
                contact: (this.enquiryForm && this.enquiryForm.getRawValue() && this.enquiryForm.getRawValue().contact) ? this.enquiryForm.getRawValue().contact : '',
                address: (this.enquiryForm && this.enquiryForm.getRawValue() && this.enquiryForm.getRawValue().address) ? this.enquiryForm.getRawValue().address : '',
                message: (this.enquiryForm && this.enquiryForm.getRawValue() && this.enquiryForm.getRawValue().message) ? this.enquiryForm.getRawValue().message : '',
                course_id : this.selectedCourse?.id
            };
            this.enquiryService.add(params).subscribe(data =>{
                console.log(data)
                this.selectedCourse.name = 'Select a Course';
                this.enquiryForm.reset();
                this.formSubmitted.emit(true);
                this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
            }
        )
        }


    }
}
